import PropTypes from 'prop-types';

export const pendingSlackLinkShape = PropTypes.shape({
    team_id: PropTypes.string.isRequired,
    team_name: PropTypes.string.isRequired,
    slack_user_id: PropTypes.string.isRequired,
    confirm_token: PropTypes.string.isRequired,
});
